/**
 * Created by CoolGuy on 2017/4/11.
 */
import thunkMiddleware from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default (reducer, initialState) => {
  return createStore(
    reducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware // 允许我们 dispatch() 函数
      )
    )
  );
};


// WEBPACK FOOTER //
// ./src/configureStore.js